import React from "react";
import { Tag } from "@geist-ui/core";
import { INVESTMENT_STATE } from "../../types/investment_types";
import theme from "../../theme";

type InvestmentStatusChipProps = {
  state: INVESTMENT_STATE | string;
};

export default function InvestmentStatusChip({
  state,
}: InvestmentStatusChipProps) {
  return <InvestmentStatusChipV2 state={state} />;
}

export function InvestmentStatusChipV2({ state }: InvestmentStatusChipProps) {
  let text = "";
  let color = "#666";

  switch (state) {
    case INVESTMENT_STATE.WAITING_FOR_ACCEPTANCE:
      text = "In Bearbeitung";
      color = "#f5a623";
      break;
    case INVESTMENT_STATE.SIGNATURE_PENDING:
      text = "Unterschrift ausstehend";
      color = "#f5a623";
      break;
    case INVESTMENT_STATE.KYC_INSUFFICIENT:
    case INVESTMENT_STATE.KYC_INVALID:
    case INVESTMENT_STATE.KYC_PENDING:
    case INVESTMENT_STATE.SIGNED:
    case INVESTMENT_STATE.WAITING_FOR_YOUSIGN:
      text = "Annahme ausstehend";
      color = "#f5a623";
      break;
    case INVESTMENT_STATE.ACCEPTED:
      text = "Zahlung ausstehend";
      color = "#f5a623";
      break;
    case INVESTMENT_STATE.PAID:
      text = "Bezahlt";
      color = "#0070f3"; // Vercel Blue
      break;
    case INVESTMENT_STATE.DELIVERED:
      text = "Eingebucht";
      color = "#17c964"; // Success Green
      break;
    case INVESTMENT_STATE.REJECTION:
      text = "Abgelehnt";
      color = "#ee0000";
      break;
    default:
       text = "Unbekannt";
  }

  return (
    <span style={{ 
        display: 'inline-flex', 
        alignItems: 'center', 
        height: '24px',
        padding: '0 8px 0 6px', 
        borderRadius: '100px', 
        border: '1px solid #eaeaea', 
        background: '#fff',
        maxWidth: 'fit-content'
    }}>
      <span style={{ 
          width: '8px', 
          height: '8px', 
          borderRadius: '50%', 
          backgroundColor: color, 
          marginRight: '6px',
          display: 'block'
      }}></span>
      <span style={{ 
          color: '#444', 
          fontSize: '12px', 
          fontWeight: 500,
          lineHeight: 1,
          whiteSpace: 'nowrap'
      }}>{text}</span>
    </span>
  );
}
